import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f308638"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed } from 'vue';
import { useModal, useInfo } from '@/store';
import { useImgSrc } from './useBaseImg';

export default /*#__PURE__*/_defineComponent({
  __name: 'PlayBtn',
  props: {
    cover: null,
    youtubeId: null
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0bea70f0": (_unref(playButton).pc),
  "3df734ca": (_unref(playButtonActive).pc)
}))

const { openModal, setCover, setYoutube, playVideo } = useModal();

const images = useImgSrc();
const imagesSrcList = Object.values(images).reduce((acc: string[], curr ) => {
  return [...acc, curr.pc, curr.mobile];
}, []);
const { getImg } = useInfo();
const playButton = computed(() => ({
  pc: `url(${getImg('anniversary_pc_play')})`,
}));
const playButtonActive = computed(() => ({
  pc: `url(${getImg('anniversary_pc_play_active')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "play",
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openModal)(true), _unref(setCover)(__props.cover), _unref(setYoutube)(__props.youtubeId), _unref(playVideo)(true)))
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imagesSrcList), (item, index) => {
      return (_openBlock(), _createElementBlock("img", {
        style: {"display":"none"},
        key: index,
        src: item || undefined,
        alt: ""
      }, null, 8, _hoisted_1))
    }), 128))
  ], 64))
}
}

})